// extracted by mini-css-extract-plugin
export default {"ticketsMainContainer":"Tickets_ticketsMainContainer__qCmqS"};